'use client';

import { useDecisions } from '../../hooks';
import { AfterPayLegacy } from './AfterPay.legacy';

export const AfterPayScript = () => {
    const isOneTrust = useDecisions('onetrust');

    if (isOneTrust) return null;

    return <AfterPayLegacy />;
};
